import { SVGProps } from "react";
import styles from "../variants/01/sw-categories-variant-01.module.scss";

export const CategoryHatchSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 812.3 282.3"
    style={{
      // @ts-ignore
      enableBackground: "new 0 0 812.3 282.3",
    }}
    xmlSpace="preserve"
    {...props}
  >
    {/* <style>{".st0{fill:#2f333e}"}</style> */}
    <path
      className={styles.st0}
      d="M142.1 179.5c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.9-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9S203 255 203 221.4s-27.2-60.9-60.9-60.9zM660.8 179.5c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9z"
    />
    <path
      className={styles.st0}
      d="m809.5 167.3-.7-.7c-3.2-3.6-7.6-8.4-7.6-16.2 0-12.8-48.6-58.2-203-58.3C586.4 85 446.9 1.7 383.7 1.7c-13.1 0-27.5-.3-44.2-.7C274.7-.5 186-2.5 67.7 12.7l-5.4.7 4 3.6c3.7 3.4 7.8 8 9 10.4-3.9 3.6-17.1 15.7-30.2 28.8-32 32.2-32 39.8-32 42.2v52.4C9.2 152.6 0 157.5 0 165.6V200l.3.5c.2.4 22.3 41.5 66.5 41.5h8.4c-.5-1.6-1-3.3-1.3-5-1.2-5-1.8-10.3-1.8-15.7 0-38.6 31.4-70 70-70s70 31.4 70 70c0 5.4-.6 10.6-1.8 15.7-.4 1.7-.8 3.4-1.3 5H593.8c-.5-1.6-1-3.3-1.3-5-1.2-5-1.8-10.3-1.8-15.7 0-38.6 31.4-70 70-70s70 31.4 70 70c0 5.4-.6 10.6-1.8 15.7-.4 1.7-.8 3.4-1.3 5H780.4c3.4 0 21.6-1 27-23 5-19.9 6.9-46.2 2.1-51.7zm-6.9 50.6c-4.9 20-21.6 19.3-22.3 19.2h-46.2c1.1-5.1 1.7-10.3 1.7-15.7 0-41.4-33.7-75-75-75s-75 33.6-75 75c0 5.4.6 10.6 1.6 15.7H215.5c1.1-5.1 1.7-10.3 1.7-15.7 0-41.4-33.7-75-75-75s-75 33.6-75 75c0 5.4.6 10.6 1.7 15.7h-2c-38.4 0-59.1-33.7-61.7-38.3v-33.2c0-5.5 8.3-9.6 11.4-10.7l1.7-.6V98.4c0-9.7 37.8-47 61.7-68.3l.9-.8-.3-1.3c-.3-3.2-4-7.7-7.2-11C188.9 2.6 275.7 4.5 339.4 6c16.7.4 31.1.7 44.3.7 63.2 0 211.1 89.2 212.5 90.1l.6.4h.7c83.1 0 132.1 13.2 158.6 24.2 30.2 12.6 40.1 25.9 40.1 29.1 0 9.7 5.3 15.6 8.9 19.5l.7.7c2.2 2.6 2.4 24.3-3.2 47.2z"
    />
    <path
      className={styles.st0}
      d="M207.7 112.5H182c-2.7 0-5-2.2-5-5 0-2.7 2.2-5 5-5h25.6c2.7 0 5 2.2 5 5s-2.2 5-4.9 5zM377.7 117.5h-25.6c-2.7 0-5-2.2-5-5 0-2.7 2.2-5 5-5h25.6c2.7 0 5 2.2 5 5s-2.2 5-5 5zM348.6 16.8H205.3c-31 0-56 25.1-56 56v5.4c0 5.6 4.4 10.1 10 10.2L553 95.6c3.4.1 4.5-4.6 1.3-6l-93.8-45.1C426 26.3 387.6 16.8 348.6 16.8z"
    />
  </svg>
);
